export function getSearchParam(name: string): string | null {
    return new URL(document.location.href).searchParams.get(name);
}
